import { faBars, faHouse, faSearch, faXmark, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import GoTop from '../Tools/GoTop';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const pfp1 = "https://dt7j04u1665qi.cloudfront.net/Haideries-main-logo.webp";

const Header = ({ visible }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [showLogo, setShowLogo] = useState(false);
  const [isHeaderVisible, setIsHeaderVisible] = useState(false);
  const location = useLocation();

  const heroPages = ['/', '/SellYourProperty', '/BuyWithHaideries', '/RentWithHaideries', '/WhyHaideries', '/ComingSoon'];
  const hasHeroBanner = heroPages.includes(location.pathname);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const closeMenu = () => {
    setShowMenu(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsHeaderVisible(scrollPosition >= 8);
    };

    window.addEventListener('scroll', handleScroll);

    const logoAnimationDelay = setTimeout(() => {
      setShowLogo(true);
    }, 300);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(logoAnimationDelay);
    };
  }, []);

  // Close menu on route change
  useEffect(() => {
    setShowMenu(false);
  }, [location.pathname]);

  const shouldDisplayHeader = !hasHeroBanner || isHeaderVisible || visible;

  return (
    <>
      <GoTop />
      <header
        id="main-nav-header"
        className={`fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-sm transition-all duration-300 ${
          shouldDisplayHeader ? 'translate-y-0 opacity-100 pointer-events-auto' : '-translate-y-full opacity-0 pointer-events-none'
        }`}
      >
        <div className="py-3 px-4 sm:px-6 md:px-8">
          <div className="max-w-7xl mx-auto flex items-center justify-between">
            <Link
              to='/'
              className="flex items-center"
              onClick={() => { window.scrollTo({ top: 0, behavior: "smooth" }); }}
            >
              {showLogo && (
                <div className="w-36 sm:w-48 md:w-56 text-black">
                  <img
                    src={pfp1}
                    className="w-full h-auto object-contain"
                    loading="lazy"
                    alt="Haideries Logo"
                  />
                </div>
              )}
            </Link>

            {/* Mobile Hamburger Button */}
            <div className="md:hidden">
              <button
                onClick={toggleMenu}
                aria-label="Toggle navigation menu"
                className="text-black p-2 rounded-md hover:bg-gray-100 text-lg"
              >
                <FontAwesomeIcon icon={faBars} />
              </button>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden font-light md:flex items-center space-x-6 text-sm tracking-wider">
              <Link to="/connect" className="text-black hover:text-bluColor flex items-center py-1">
                <FontAwesomeIcon icon={faSearch} className='mr-2' /> PROPERTY SEARCH
              </Link>
              <div className="h-4 border-r border-gray-300"></div>
              <Link to='/ListProperty' className="text-black hover:text-bluColor flex items-center py-1">
                <FontAwesomeIcon icon={faHouse} className='mr-2' /> LIST YOUR PROPERTY
              </Link>
              <div className="h-4 border-r border-gray-300"></div>
              <button
                onClick={toggleMenu}
                className="text-black hover:text-bluColor flex items-center py-1 font-medium cursor-pointer"
              >
                <FontAwesomeIcon icon={faBars} className='mr-2' /> MENU
              </button>
            </nav>
          </div>
        </div>
      </header>

      {/* Mobile Backdrop Overlay */}
      {showMenu && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-xs z-50 transition-opacity duration-300"
          onClick={closeMenu}
          aria-hidden="true"
        />
      )}

      {/* Slide-out Drawer */}
      <div
        className={`fixed top-0 right-0 bottom-0 w-4/5 max-w-sm bg-white z-50 shadow-2xl flex flex-col justify-between overflow-y-auto transform transition-transform duration-300 ease-in-out ${
          showMenu ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="p-6">
          <div className="flex items-center justify-between pb-6 border-b border-gray-200">
            <span className="text-xl font-bold tracking-widest text-black">HAIDERIES</span>
            <button
              onClick={closeMenu}
              aria-label="Close menu"
              className="p-2 text-gray-700 hover:text-black rounded-md hover:bg-gray-100"
            >
              <FontAwesomeIcon icon={faXmark} className="text-xl" />
            </button>
          </div>

          <nav className="mt-6 flex flex-col space-y-3 tracking-wide">
            <Link
              to="/"
              onClick={closeMenu}
              className="px-4 py-3 text-sm font-medium text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
            >
              Home
            </Link>
            <Link
              to="/RoadShows"
              onClick={closeMenu}
              className="px-4 py-3 text-sm font-medium text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
            >
              International Roadshows
            </Link>
            <Link
              to="/ListProperty"
              onClick={closeMenu}
              className="px-4 py-3 text-sm font-medium text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
            >
              List Your Property
            </Link>
            <Link
              to="/WhyHaideries"
              onClick={closeMenu}
              className="px-4 py-3 text-sm font-medium text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
            >
              About Haideries
            </Link>
            <Link
              to="/BuyersGuide"
              onClick={closeMenu}
              className="px-4 py-3 text-sm font-medium text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
            >
              Buyers Guide
            </Link>
            <Link
              to="/SellersGuide"
              onClick={closeMenu}
              className="px-4 py-3 text-sm font-medium text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
            >
              Sellers Guide
            </Link>
            <Link
              to="/BookValuation"
              onClick={closeMenu}
              className="px-4 py-3 text-sm font-medium text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
            >
              Book a Valuation
            </Link>
            <Link
              to="/Contact"
              onClick={closeMenu}
              className="px-4 py-3 text-sm font-medium text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
            >
              Contact Us
            </Link>
          </nav>
        </div>

        <div className="p-6 border-t border-gray-200 bg-gray-50 text-xs text-gray-500">
          <p className="font-semibold text-gray-700 mb-1">Haideries Real Estate</p>
          <p>Dubai, UAE</p>
          <p className="mt-1">+971 54 299 9975</p>
        </div>
      </div>

      {/* Floating Action Buttons (FAB) */}
      <div className="fixed bottom-5 right-4 sm:bottom-6 sm:right-6 flex flex-col gap-3 z-40 items-end">
        <a
          href="https://wa.me/+971502607861"
          target="_blank"
          rel="noopener noreferrer"
          className="w-12 h-12 sm:w-14 sm:h-14 bg-green-500 hover:bg-green-600 text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-105 transition-all text-xl sm:text-2xl"
          aria-label="Open WhatsApp"
        >
          <FontAwesomeIcon icon={faWhatsapp} />
        </a>
        <a
          href="tel:+971502607861"
          target="_blank"
          rel="noopener noreferrer"
          className="w-12 h-12 sm:w-14 sm:h-14 bg-bluColor hover:bg-[#3b516d] text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-105 transition-all text-lg sm:text-xl"
          aria-label="Call Us"
        >
          <FontAwesomeIcon icon={faPhone} />
        </a>
      </div>
    </>
  );
};

export default Header;
